module.exports = __webpack_public_path__ + "static/media/abs-sagip.c57e369a.png";